import { getBaseMarketplaceAppUrl } from 'features/marketplace/config/env';

export const getIframeOrigins = () => {
  const marketplaceAppUrl = getBaseMarketplaceAppUrl();
  const marketplaceOrigin = new URL(marketplaceAppUrl).origin;
  const currentOrigin = window.location.origin;

  return {
    marketplace: marketplaceOrigin,
    current: currentOrigin,
    // Add other iframe origins here as needed
  };
};

export const getAllowedOrigins = (includeCurrentOrigin = true) => {
  const origins = getIframeOrigins();
  const allowedOrigins = [origins.marketplace];

  // In development, also allow same origin for testing
  if (
    includeCurrentOrigin &&
    (process.env.NODE_ENV === 'development' ||
      origins.current !== origins.marketplace)
  ) {
    allowedOrigins.push(origins.current);
  }

  return allowedOrigins;
};

export const isValidIframeOrigin = (
  origin: string,
  includeCurrentOrigin = true,
) => {
  const allowedOrigins = getAllowedOrigins(includeCurrentOrigin);
  return allowedOrigins.includes(origin);
};
